import { Component, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { AccountManagementRoutes } from '../../account-management.routes';
import { Router, ActivatedRoute } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { AccountManagementService } from '../../services/account-management.service';
import { WebLogin } from '../../models/web-login.model';
import { ToasterService } from '../../../../common/services/toaster.service';
import { WebLoginWithReports } from '../../models/web-login-with-reports.model';
import { Customer } from '../../../../common/models/customer-model';
import { WebLoginDept } from '../../models/web-login-dept.model';
import { CustomerDepartment } from '../../../../common/models/customer-department-model';

@Component({
  selector: 'app-edit-user-page',
  templateUrl: 'edit-user.page.html',
  styleUrls: [
    './edit-user.page.scss',
    '../../styles/account-management.styles.scss',
  ],
})
export class EditUserPage implements OnInit, ViewWillEnter {
  currentRoute: string;

  customerCancelReport: boolean = false;
  garmentReturnReview: boolean = false;

  login: string | null = "";
  password: string = "";
  firstName: string = "";
  lastName: string = "";
  userStatus: string = '0';
  userType: string = 'user';
  placeOrders: boolean = false;
  viewInvoices: boolean = false;
  viewTransfers: boolean = false;
  cancelEmp: boolean = false;
  requestParams: any;
  results: WebLoginWithReports = new WebLoginWithReports;
  type: any;
  customer: string = "";
  departmentCode: string = ""
  department: string[] = [];
  customerList: Customer[] = [];
  departmentList: CustomerDepartment[] = [];
  reports: any[] = [];
  loaded: boolean = false;
  selectedDepartments: string[] = [];
  customerName: string = "";
  isCostCenter: Boolean = false;
  groupedCustomers: any[] = [];
  statusCodes = {
    0: 'Active',
    1: 'Disabled',
  };

  userTypeCodes = {
    0: 'User',
    1: 'Admin',
    2: 'Internal User',
    4: 'Route Driver',
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: GtrakAuthService,
    private accountService: AccountManagementService,
    private toasterService: ToasterService
  ) {
    this.currentRoute = "";
  }

  ngOnInit(): void {

    this.requestParams = new RequestParams();

    if (!this.authService.user.canViewAccountManagement) {
      this.router.navigate([this.authService.user.homeLocation]);
    }

    this.currentRoute = this.router.url;
  }

  async ionViewWillEnter() {
    this.loaded = false;
    this.login = this.route.snapshot.paramMap.get('login');
    await this.getAccount();
    await this.getCustomerCodes();
    await this.checkCostCenter();
    if (this.isCostCenter) {
      this.getCostCenterAssigned();
    }

    this.loaded = true;
  }
  getReports() {

  }

  selectUserType(type: any): void {
    if (type.detail.value == 'User') {
      this.userType = 'user';
    } else if (type.detail.value == 'Admin') {
      this.userType = 'admin';
    } else if (type.detail.value == 'Route Driver') {
      this.userType = 'driver';
    } else {
      this.userType = 'user';
    }
  }

  async getAccount() {
    // this.loaded=false;
    this.results = await this.accountService.GetUserByLogin(this.login);
    const user = this.results.webLogin;
    this.customerName = this.results.customerName;
    // Code 9 is cancel report and 10 is return review
    this.reports = this.results.webReports;
    const departments = this.results.webLoginDept;

    this.userStatus = user.disabled;

    this.firstName = user.fname;
    this.lastName = user.lname;
    this.customer = user.customerCode;
    if (departments.length > 0) {
      this.customer = departments[0].customerCode;
    }
    if (departments.length > 0) {
      this.departmentCode = departments[0].departmentCode;
    }
    const map = new Map<string, any>();
    departments.forEach(item => {

      if (!map.has(item.customerCode)) {
        map.set(item.customerCode, {
          customerCode: item.customerCode,
          customerName: item.name,
          departments: []
        });
      }

      map.get(item.customerCode).departments.push({
        departmentCode: item.departmentCode,
        description: item.description
      });
    });

    this.groupedCustomers = Array.from(map.values());

    //check if placeOrder is one or zero
    if (user.placeOrder === '1') {
      this.placeOrders = true;
    } else {
      this.placeOrders = false;
    }
    //check if viewInvoices is one or zero
    if (user.viewInvoice === '1') {
      this.viewInvoices = true;
    } else {
      this.viewInvoices = false;
    }
    //check if viewTransfers is one or zero
    if (user.viewEmpTransfer === '1') {
      this.viewTransfers = true;
    } else {
      this.viewTransfers = false;
    }

    //check if cancelEmp is one or zero
    if (user.cancelEmp === '1') {
      this.cancelEmp = true;
    } else {
      this.cancelEmp = false;
    }
    switch (user.userType) {
      case 'user':
      case 'USER':
        this.type = 'User';
        break;
      case 'admin':
        this.type = 'Admin';
        break;
      case 'driver':
        this.type = 'Route Driver';
        break;
    }
    // this.loaded=true;  
  }

  async submit() {
    this.loaded = false;
    var wlr = new WebLoginWithReports();
    wlr.webLogin = new WebLogin();
    wlr.webLogin.login = this.login ?? "";
    wlr.webLogin.password = this.password;
    wlr.webLogin.fname = this.firstName;
    wlr.webLogin.lname = this.lastName;
    wlr.webLogin.disabled = this.userStatus;
    wlr.webLogin.userType = this.userType;
    if (this.placeOrders == true) {
      wlr.webLogin.placeOrder = '1';
    } else {
      wlr.webLogin.placeOrder = '0';
    }
    if (this.viewInvoices == true) {
      wlr.webLogin.viewInvoice = '1';
    } else {
      wlr.webLogin.viewInvoice = '0';
    }
    if (this.viewTransfers == true) {
      wlr.webLogin.viewEmpTransfer = '1';
    } else {
      wlr.webLogin.viewEmpTransfer = '0';
    }
     if (this.cancelEmp == true) {
      wlr.webLogin.cancelEmp = '1';
    } else {
      wlr.webLogin.cancelEmp = '0';
    }
    wlr.webLogin.customerCode = this.customer ?? '';
    wlr.webLogin.departmentCode = this.departmentCode ?? '';
    wlr.webLogin.employeeCode = '';

    //for each department in the department array, create a new WebLoginDept object and push it to the webLoginDept array
    // wlr.webLoginDept = [];
    // this.department.forEach((department) => {
    //   var wld = new WebLoginDept();
    //   wld.login = this.login;
    //   wld.customerCode = this.customer;
    //   wld.departmentCode = department;
    //   wlr.webLoginDept.push(wld);
    // });

    try {
      let resp = await this.accountService.EditUser(wlr);
      var reports = this.reports.filter(r => r.hasAccess === true);
      // Add user from review report
      if (reports.length > 0) {
        await this.accountService.EditReport(this.login ?? "", reports);
      }

      this.toasterService.presentToast(
        'primary',
        '',
        'User updated successfully.',
        1000
      );
      this.password = '';
      this.router.navigate(['/account-management']);
    } catch (error) {
      console.log(error);
      this.toasterService.presentToast(
        'danger',
        '',
        'An error occurred while updating user. Please try again.',
        1000
      );
    }
    this.loaded = true;
  }

  async getCustomerCodes() {
    this.customerList = await this.accountService.GetCustomerCodes();
  }

  async getDepartmentCodes(event: any, inHTML = false) {
    if (inHTML) {
      this.departmentList = [];
      this.department = [];
    }
    this.departmentList = await this.accountService.GetDepartmentsByCustomer(
      event
    );
  }
  async manageUser() {

    if (this.isCostCenter) {
      this.router.navigate(['/account-management/edit/manage-cost-center/' + this.login]);
    }
    else {
      localStorage.setItem('customerName', this.firstName + " " + this.lastName)
      this.router.navigate(['/account-management/edit/manage-department/' + this.login]);
    }
  }
  async getCostCenterAssigned() {
    this.loaded = false;
    this.departmentList = await this.accountService.GetCostCenterAssigment(this.login ?? "");
    if (this.departmentList.length > 0) {
      this.departmentCode = this.departmentList[0].departmentCode;
    }
    this.loaded = true;
  }
  async checkCostCenter() {
    this.loaded = false;
    this.isCostCenter = await this.accountService.CheckCostCenter(this.results.webLogin.customerCode);
    this.loaded = true;
  }
}
